import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const getFirebaseErrorMessage = (errorCode: string): string => {
    const errorMessages: Record<string, string> = {
        "auth/invalid-email": "L'email inserita non è valida.",
        "auth/user-not-found": "Nessun utente trovato con questa email.",
        "auth/wrong-password": "Password errata. Riprova.",
        "auth/email-already-in-use": "L'email è già in uso. Prova ad accedere.",
        "auth/weak-password": "La password è troppo debole. Scegline una più sicura.",
        "auth/missing-password": "Inserisci una password.",
        "auth/network-request-failed": "Errore di connessione. Controlla la tua rete.",
        "auth/too-many-requests": "Troppi tentativi di accesso. Riprova più tardi.",
        "auth/user-disabled": "Questo account è stato disabilitato.",
        "auth/requires-recent-login": "Per questa operazione è necessario un nuovo login.",
        "auth/operation-not-allowed": "Operazione non consentita. Contatta il supporto.",
        "auth/invalid-credential": "Credenziali non valide. Controlla email e password.",
        "auth/missing-email": "Inserisci un'email.",
        "auth/popup-closed-by-user": "Accesso interrotto. Riprova.",
        "auth/account-exists-with-different-credential": "L'account esiste già con un altro metodo di accesso.",
    };

    return errorMessages[errorCode] || "Si è verificato un errore imprevisto. Riprova.";
};

export function currentPage(pathName: string, path: string) {
    if (pathName === path) {
        return "font-bold"
    }
}
